import { render, staticRenderFns } from "./MailingCampaignForm.vue?vue&type=template&id=23a403e4&"
import script from "./MailingCampaignForm.vue?vue&type=script&lang=js&"
export * from "./MailingCampaignForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports